(function (){
    'use strict';

    angular
        .module('services')
        .service('PermissionService', PermissionService);

    PermissionService.$inject = ['$http', 'API_BASE'];

    function PermissionService ($http, API_BASE) {
        var service = this;


        service.getPermissions  = getPermissions;
        service.getPermissionsById  = getPermissionsById;


        function getPermissions () {
            return $http.get(API_BASE + '/permissions');
        }

        function getPermissionsById (id) {
            return $http.get(API_BASE + '/permissions/'+id);
        }


    }
})();